<nav class="navbar navbar-expand-lg navbar-light" id="topnav">
  <div class="container-fluid ps-3 pe-3">

    <!-- Toggler -->
    <button aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler me-auto"
            data-bs-target="#navbar" data-bs-toggle="collapse" type="button">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Brand -->
    <a class="navbar-brand me-auto" href="../../../index.html">
      <img alt="..." class="navbar-brand-img" src="../../../assets/images/logo-blue@3x.png">
    </a>

    <!-- User -->
    <div class="navbar-user">

      <!-- Dropdown -->
      <div class="dropdown">

        <!-- Toggle -->
        <a aria-expanded="false" aria-haspopup="true" class="avatar avatar-sm avatar-online dropdown-toggle"
           data-bs-toggle="dropdown" href="#" role="button">
          <img [src]="pictureUrl" alt="..." class="avatar-img rounded-circle">
        </a>

        <!-- Menu -->
        <div class="dropdown-menu dropdown-menu-end">
          <li class="dropdown-item no-hover">{{ email }}</li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <a (click)="auth.logout({
                    logoutParams: {
                            returnTo: getReturnUrl()
                            }
                        })" class="dropdown-item" href="#">Se déconnecter</a>
        </div>

      </div>

    </div>

    <!-- Collapse -->
    <div class="collapse navbar-collapse me-lg-auto order-lg-first" id="navbar">

      <!-- Navigation -->
      <ul class="navbar-nav me-lg-auto">
        <li class="nav-item">
          <a aria-expanded="true" aria-haspopup="true" class="nav-link active" href="#"
             id="topnavDashboards" role="button" routerLink="/">
            Accueil
          </a>
        </li>
      </ul>

    </div>

  </div> <!-- / .container -->
</nav>
